(() => {
  window.PXUTheme = window.PXUTheme || {};

  window.PXUTheme.jsBlog = {
    init(section) {
      // получаем данные секции (без $.extend)
      const data = window.PXUTheme.getSectionData(section);
      Object.assign(this, data);

      this.filterEl = document.getElementById('blog_filter');

      if (this.enable_filter && this.filterEl) {
        this.onChange = this.blogFilter.bind(this);
        this.filterEl.addEventListener('change', this.onChange);
      }
    },

    blogFilter() {
      const url = this.filterEl?.value;
      if (url) {
        window.location.href = url;
      }
    },

    unload() {
      if (this.filterEl && this.onChange) {
        this.filterEl.removeEventListener('change', this.onChange);
      }
    }
  };
})();